// extracted by mini-css-extract-plugin
export var statItem = "_c4-1";
export var statsRow = "_c4-0";